import { ReactNode } from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import {
  AttachmentManager,
  IAttachmentsProps,
} from '@/web/components/AttachmentManager';

interface IProps<T extends FieldValues>
  extends Omit<IAttachmentsProps, 'id' | 'onChange' | 'attachments'> {
  name: Path<T>;
  control?: Control<T>;
  transform?: (value: string) => string;
  title: string;
  description: ReactNode;
  addLabel: string;
  dropLabel: string;
}

export const ControlledAttachment = <T extends FieldValues>({
  name,
  control,
  title,
  description,
  addLabel,
  dropLabel,
  ...restProps
}: IProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, ...field } }) => (
        <AttachmentManager
          {...field}
          {...restProps}
          attachments={field.value}
          title={title}
          description={description}
          onChange={(value) => {
            field.onChange(value);
          }}
          addLabel={addLabel}
          dropLabel={dropLabel}
        />
      )}
    />
  );
};
